export default["__VITE_ASSET__BEGbrvFN__","__VITE_ASSET__ChYa3EQp__"];